var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:_vm.active ? 'active' : ''},[_c('div',{staticClass:"avatar"},[_c('head-image',{attrs:{"url":_vm.group.headImage}})],1),_c('div',{staticClass:"text"},[_c('div',[_vm._v(_vm._s(_vm.group.remark))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }